import React, { useEffect, useRef } from "react"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import { EdlynLogo, BoneLogo, WoodsLogo, GreenWheatLogo, SunnySideLogo } from "../../icons"
import { StructuredText } from "react-datocms/structured-text"
import AnimationButton from "./animation-button";

const TitleBrandItem = ({ title, items, rowLayout, amazonLink }) => {

  return (
    <section className={`tbi${rowLayout ? " tbi--row" : ""}${rowLayout ? " tbi--amazon" : ""}`} id="brands">
      <div className="tbi__inner">
        {title && <h2>{parse(title)}</h2>}
        <div className="tbi__items">
          {items?.length > 0 && items.map((item, index) => (
            <div key={index} className={`tbi__item ${item.brand}`} data-sal="slide-up" data-sal-duration="1000"
                 data-sal-easing="ease">
              <div className="tbi__item-brand">
                {
                  (() => {
                    switch (item.brand) {
                      case "woods":
                        return <WoodsLogo />
                      case "bone":
                        return <BoneLogo />
                      case "greenwheat":
                        return <GreenWheatLogo />
                      case "sunnyside":
                        return <SunnySideLogo color="#FD5C3F" />
                      default:
                        return <EdlynLogo />
                    }
                  })()
                }
              </div>
              <div className="tbi__item-content">
                <StructuredText data={item.richContent} />
                <AnimationButton
                  className="btn"
                  to={(() => {
                    if (amazonLink) {
                      return amazonLink
                    }
                    switch (item.brand) {
                      case "edlyn":
                        return "/edlyn/"
                      case "woods":
                        return "/woods/"
                      case "bone":
                        return "/bone-roasters/"
                      case "greenwheat":
                        return "/greenwheat-freekeh/"
                      case "sunnyside":
                        return "/sunnyside/"
                      default:
                        return "/"
                    }
                  })()
                  }>
                  Explore {(() => {
                  switch (item.brand) {
                    case "edlyn":
                      return "Edlyn"
                    case "woods":
                      return "Woods"
                    case "bone":
                      return "Bone Roasters"
                    case "greenwheat":
                      return "Greenwheat Freekeh"
                    case "sunnyside":
                      return "Sunnyside"
                    default:
                      return "/"
                  }
                })()
                }
                </AnimationButton>
              </div>
              {item.rolloverImage && <Asset asset={item.rolloverImage} />}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TitleBrandItem

export const query = graphql`
  fragment TitleBrandItemProps on DatoCmsTitleBrandItem {
    ... on DatoCmsTitleBrandItem {
      id
      title
      items {
        brand
        richContent {
          value
        }
        rolloverImage {
          ...InternalAssetProps
        }
      }
      rowLayout
      amazonLink
    }
  }
`